var map = {
	"./contact/CreateMainComponent": 950,
	"./cpo/CreateMainComponent": 951,
	"./customer/CreateMainComponent": 952,
	"./forwarderPo/CreateMainComponent": 953,
	"./incomingInvoice/CreateMainComponent": 954,
	"./incomingPayment/CreateMainComponent": 955,
	"./outgoingInvoice/CreateMainComponent": 956,
	"./outgoingPayment/CreateMainComponent": 1097,
	"./outgoingQuote/CreateMainComponent": 957,
	"./product/CreateMainComponent": 958,
	"./receiving/CreateMainComponent": 959,
	"./shipping/CreateMainComponent": 960,
	"./spo/CreateMainComponent": 961,
	"./spoSched/CreateMainComponent": 962,
	"./vatDeductRecord/CreateMainComponent": 963,
	"./vendor/CreateMainComponent": 964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 949;